import { Card, Image } from "antd";
import { RightOutlined } from "@ant-design/icons";
import "./css/inspiration-card-web.css";

const InspirationCardWeb = ({ item, onOpen }) => {
    const metaParts = [item?.category?.name, item?.platform].filter(Boolean);
    const metaLine = metaParts.join(" · ");

    return (
        <Card
            hoverable
            className="editorial-card"
            onClick={() => onOpen(item)}
            bodyStyle={{
                padding: 0,
                display: "flex",
                flexDirection: "column",
                height: "100%",
                overflow: "hidden",
            }}
        >
            <div className="editorial-media">
                <Image
                    src={item.projectFeatureImage}
                    preview={false}
                    className="editorial-image"
                />
            </div>

            <div className="editorial-footer">
                <div className="editorial-footer-inner">
                    {item.projectLogo ? (
                        <div className="editorial-logo">
                            <Image src={item.projectLogo} preview={false} />
                        </div>
                    ) : (
                        <div className="editorial-logo editorial-logo--placeholder" aria-hidden>
                            {item?.projectTitle?.charAt(0)?.toUpperCase() || "·"}
                        </div>
                    )}
                    <div className="editorial-footer-copy">
                        <div className="editorial-title">{item.projectTitle}</div>
                        {metaLine ? <div className="editorial-meta">{metaLine}</div> : null}
                    </div>
                </div>
                <RightOutlined className="editorial-foot-chevron" aria-hidden />
            </div>
        </Card>
    );
};

export default InspirationCardWeb;
